/*  Reference:
* https://devsupport.zoom.us/hc/en-us/articles/360060333351-How-to-use-the-Web-Meeting-SDK-in-an-Angular-App
* https://github.com/zoom/meetingsdk-angular-sample
* https://medium.com/zoom-developer-blog/zoom-web-sdk-with-angular-6b080a6be38c
*/

import { Component, Inject, OnInit } from '@angular/core';
// import { ZoomMtg } from '@zoomus/websdk';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { UserInfoService } from 'app/BaseFramework';

// ZoomMtg.preLoadWasm();
// ZoomMtg.prepareWebSDK();
// // loads language files, also passes any error messages to the ui
// ZoomMtg.i18n.load('en-US');
// ZoomMtg.i18n.reload('en-US');

@Component({
  selector: 'app-online-meeting',
  templateUrl: './online-meeting.component.html',
  styleUrls: ['./online-meeting.component.scss']
})
export class OnlineMeetingComponent implements OnInit {

  constructor(public httpClient: HttpClient,
    @Inject(DOCUMENT) document,
    private userInfoService: UserInfoService) {

  }

  ngOnInit() {

  }

  environment = environment;
  signatureEndpoint = 'ZFZGdXFUSDRUbHlXV3kxcnQxUTVody45NTA2NzU5MDUxMS4xNjA2MTIxNDYzNzcwLjEuN0oxWHBDTE1uUHh2aW1JQ3I0bUdFSThPRnlGbVVFN2ZoRERrT3dLcHByVT0';
  sdkKey = ''
  meetingNumber = environment['zoomMeetingNumber']
  role = 0
  leaveUrl = 'http://localhost:4202/'
  userName = this.userInfoService.getUserName()
  userEmail = ''
  passWord = ''

  // getSignature() {

  //   this.httpClient.post(this.signatureEndpoint, {
  //     meetingNumber: this.meetingNumber,
  //     role: this.role
  //   }).toPromise().then((data: any) => {
  //     if (data.signature) {
  //       console.log(data.signature)
  //       this.startMeeting(data.signature)
  //     } else {
  //       console.log(data)
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //   })

  // }

  // startMeeting(signature) {
  //   let meetingSDKElement = document.getElementById('meetingSDKElement');
  //   document.getElementById('meetingSDKElement').style.display = 'block';

  //   ZoomMtg.init({
  //     leaveUrl: this.leaveUrl,
  //     isSupportAV: true,
  //     success: (success) => {
  //       console.log(success)

  //       ZoomMtg.join({
  //         signature: signature,
  //         meetingNumber: this.meetingNumber,
  //         userName: this.userName,
  //         sdkKey: this.sdkKey,
  //         userEmail: this.userEmail,
  //         passWord: this.passWord,
  //         success: (success) => {
  //           console.log(success)
  //         },
  //         error: (error) => {
  //           console.log(error)
  //         }
  //       })
  //     },
  //     error: (error) => {
  //       console.log(error)
  //     }
  //   })

  // }

}
